(function () {
  if (window.MapclubApi && window.MapclubApi.ready) return;

  var config = window.mapclubApiConfig || {};
  var mapclubProxyPath = normalizeProxyPath(
    config.proxyPath || "apps/mapclub-production",
  );
  var mapclubProxyPathPattern = new RegExp(
    "^/" + escapeRegExp(mapclubProxyPath) + "(?=/|$)",
    "i",
  );
  var brokenMapclubProxyPattern =
    /^\/([a-z]{2}(?:-[a-z]{2})?)apps(?=\/mapclub-production(?:\/|$))/i;

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeProxyPath(path) {
    return String(path || "")
      .trim()
      .replace(/^(?:\/+)|(?:\/+$)/g, "");
  }

  function normalizeLocaleRoot(path) {
    if (typeof path !== "string" || !path.length) return "/";
    if (path === "/") return path;
    return path.endsWith("/") ? path : path + "/";
  }

  function normalizeLocaleAppProxyPath(input) {
    if (!input) return input;

    try {
      var isString = typeof input === "string";
      var rawValue = isString ? input : input.toString();
      var url = new URL(rawValue, window.location.origin);
      var isSameOrigin = url.origin === window.location.origin;
      var normalizedPath = url.pathname.replace(
        brokenMapclubProxyPattern,
        "/$1/apps",
      );

      if (
        isSameOrigin &&
        normalizedPath === url.pathname &&
        mapclubProxyPathPattern.test(url.pathname)
      ) {
        normalizedPath =
          getLocaleRoot().replace(/\/$/, "") + normalizedPath;
      }

      if (normalizedPath === url.pathname) return input;

      url.pathname = normalizedPath;

      if (!isString) return url;

      return /^(https?:)?\/\//i.test(rawValue)
        ? url.toString()
        : url.pathname + url.search + url.hash;
    } catch (error) {
      return input;
    }
  }

  function getLocaleRoot() {
    var shopifyRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return normalizeLocaleRoot(shopifyRoot || config.rootUrl || "/");
  }

  function buildMapclubUrl(endpoint) {
    var cleanEndpoint = String(endpoint || "").trim().replace(/^\/+/, "");
    cleanEndpoint = cleanEndpoint.replace(
      new RegExp("^" + escapeRegExp(mapclubProxyPath) + "/?", "i"),
      "",
    );

    var url = getLocaleRoot() + mapclubProxyPath;
    if (cleanEndpoint) url += "/" + cleanEndpoint;

    return normalizeLocaleAppProxyPath(url);
  }

  function fetchMapclub(endpoint, options) {
    return window.fetch(buildMapclubUrl(endpoint), options);
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function (resource, init) {
      if (typeof resource === "string" || resource instanceof URL) {
        resource = normalizeLocaleAppProxyPath(resource);
      } else if (window.Request && resource instanceof Request) {
        var normalizedRequestUrl = normalizeLocaleAppProxyPath(resource.url);
        if (normalizedRequestUrl !== resource.url) {
          resource = new Request(normalizedRequestUrl, resource);
        }
      }

      return originalFetch.call(this, resource, init);
    };
  }

  var originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var normalizedUrl =
      typeof url === "string" || url instanceof URL
        ? normalizeLocaleAppProxyPath(url)
        : url;
    return originalXhrOpen.apply(
      this,
      [method, normalizedUrl].concat(Array.prototype.slice.call(arguments, 2)),
    );
  };

  window.__normalizeLocaleRoot = normalizeLocaleRoot;
  window.__normalizeLocaleAppProxyPath = normalizeLocaleAppProxyPath;
  window.mapclubUrl = buildMapclubUrl;
  window.mapclubFetch = fetchMapclub;
  window.MapclubApi = {
    fetch: fetchMapclub,
    proxyPath: mapclubProxyPath,
    ready: true,
    url: buildMapclubUrl,
  };
})();
